var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeedbackAccessActiveXmas(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "26px",
    viewBox: "0 0 19 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.12270007,0 L14.2582523,0 C14.8105371,5.46534823e-16 15.2582523,0.44771525 15.2582523,1 C15.2582523,1.03850371 15.2560285,1.07697529 15.251592,1.11522255 L14.5788203,6.91522255 C14.5203209,7.41954912 14.0931887,7.8 13.5854806,7.8 L1.79547174,7.8 C1.28776369,7.8 0.860631461,7.41954912 0.802132042,6.91522255 L0.12936037,1.11522255 C0.0657247101,0.566616185 0.458871149,0.0702959576 1.00747752,0.00666029825 C1.04572478,0.00222380222 1.08419636,-1.03949285e-16 1.12270007,0 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "App-Elements-Copy-7",
    transform: "translate(-528.000000, -113.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13-Copy-2",
    transform: "translate(528.000000, 113.000000)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-7",
    stroke: "#CB4F4F",
    strokeWidth: 4,
    fill: "#CB4F4F",
    cx: 9.95238095,
    cy: 18.07,
    rx: 6.33333333,
    ry: 3.33666667
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#CB4F4F",
    points: "10.8571429 19.9333333 14.4761905 19.9333333 16.2857143 25.1333333 13.5714286 24.2666667 11.7619048 26"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-2",
    stroke: "#333B47",
    strokeWidth: 2,
    fill: "#FFFFFF",
    cx: 9.5,
    cy: 12.5666667,
    rx: 7.69047619,
    ry: 7.36666667
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(4.976190, 10.400000)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fillOpacity: 0.8,
    fill: "#000A19",
    cx: 1.80952381,
    cy: 1.3,
    rx: 1.35714286,
    ry: 1.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-15",
    fillOpacity: 0.8,
    fill: "#000A19",
    cx: 7.23809524,
    cy: 1.3,
    rx: 1.35714286,
    ry: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.52380952,1.73333333 C5.27333883,1.73333333 5.88095238,2.31536316 5.88095238,3.03333333 C5.88095238,3.75130351 5.27333883,4.33333333 4.52380952,4.33333333 C4.46262282,4.33333333 4.40238185,4.32945467 4.34333996,4.32194002 L4.34285714,4.33333333 L1.62857143,3.03333333 L4.34285714,1.73333333 L4.34257143,1.74433333 L4.43226618,1.73624408 C4.46252008,1.73431386 4.49304526,1.73333333 4.52380952,1.73333333 Z",
    id: "Combined-Shape",
    fill: "#FFA735"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.80952381,5.2 C2.26190476,5.77777778 3.16666667,6.06666667 4.52380952,6.06666667 C5.88095238,6.06666667 6.78571429,5.77777778 7.23809524,5.2",
    id: "Path-8",
    strokeOpacity: 0.8,
    stroke: "#000A19",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#333B47",
    x: 0,
    y: 6.93333333,
    width: 19,
    height: 1.73333333,
    rx: 0.866666667
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-Copy",
    transform: "translate(1.809524, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#333B47",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#6EC490",
    mask: "url(#mask-2)",
    x: 0,
    y: 4.33333333,
    width: 15.3809524,
    height: 2.6
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackAccessActiveXmas);
export default __webpack_public_path__ + "static/media/feedback-access-active-xmas.82e1ec04211b4b3afac6a0fd069881ea.svg";
export { ForwardRef as ReactComponent };